import { extendDecorator, viewModelDecorator } from '@/js/common/Domain/Service/mixins/decorators';

import './assets/style.scss';
import template from './assets/template.html';

@viewModelDecorator({
    defaults: {
        covidBanner: false,
    },

    computeds: {
        bannerText: {
            get() {
                const pageName = window.funnelPage;
                /**
                 * В зависимости от того, является ли поиск на странице горящих туров, либо на СЕРПе динамически изменяется текст.
                 * Выбирается 1 / 2 и от этого меняются окончания.
                 */
                const countriesCount = +(pageName === 'tury') + 1;

                let bannerContent = '';

                bannerContent += `Стран${countriesCount.wordEnding('а;ы;')} временно ограничил${countriesCount.wordEnding('а;и;')} въезд туристов. `;
                bannerContent += `Рекомендуем поискать туры на более дальние даты или выбрать друг${countriesCount.wordEnding('ое;ие;')} направлени${countriesCount.wordEnding('е;я;')}. `;
                bannerContent += 'Подробнее об открытых странах можно узнать в нашей статье';

                return bannerContent;
            },
        },
    },
})
@extendDecorator({
    bindings: {
        ':el': 'toggle: covidBanner',
        '.js-covid-banner-text': 'text: bannerText',
    },

    template,
})
export default class CovidBannerView extends Backbone.Epoxy.View {
    initialize() {
        this.render();
        this.initViewModel();
    }

    initViewModel() {
        this.viewModel.mapState('covidBanner', this.model);
    }

    render() {
        this.$el.html(this.template);
    }
}
